import {
  Sofa, Home, Truck, Users, Boxes, Route, Building2, Landmark, ShieldCheck,
  FileText, MessageCircle, MapPin, CheckCircle2, CalendarCheck, Receipt, PackageCheck,
} from "lucide-react";

export const PHONE_DISPLAY = "07 66 92 42 57";
export const PHONE_TEL_LINK = "tel:+33766924257";
export const EMAIL = "contact@expressdeliverycontact.com";
export const EMAIL_LINK = "mailto:contact@expressdeliverycontact.com";
export const GOOGLE_BUSINESS_LINK = "https://www.google.com/search?q=Express+Delivery+Le+Havre+avis";

export const WHATSAPP_MESSAGE = `Bonjour Express Delivery, je souhaite obtenir une estimation.

Type de prestation :
Formule souhaitée :
Départ :
Arrivée :
Date :
Objets à transporter :
Étage départ :
Étage arrivée :
Ascenseur :
Aide disponible :
Photos :`;

export const WHATSAPP_LINK = `https://wa.me/33766924257?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export const NAV_LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Formules", href: "/#formules" },
  { label: "Groupage", href: "/#groupage" },
  { label: "Longue distance", href: "/#longue-distance" },
  { label: "Zones", href: "/#zones" },
  { label: "Professionnels", href: "/#clients" },
  { label: "FAQ", href: "/#faq" },
];

export const ESTIMATE_TYPE_OPTIONS = [
  "Transport de meubles",
  "Électroménager",
  "Déménagement",
  "Longue distance",
  "Groupage",
  "Débarras",
  "Manutention",
  "Livraison Leboncoin / Marketplace",
  "Autre",
];

export const FORMULES = [
  {
    key: "camion-chauffeur",
    value: "Camion + chauffeur",
    title: "Camion + chauffeur",
    text: "Vous disposez déjà de personnes pour porter ? Nous fournissons le camion, le chauffeur et l'organisation du transport.",
    includes: [
      "Camion avec chauffeur",
      "Trajet organisé",
      "Transport",
      "Sécurisation du chargement",
      "Couvertures et sangles selon le besoin",
    ],
    note: "Le chargement et le déchargement sont réalisés avec l'aide des personnes présentes sur place.",
    cta: "Choisir cette formule",
    highlighted: false,
  },
  {
    key: "aide-manutention",
    value: "Camion + chauffeur + aide à la manutention",
    title: "Camion + chauffeur + aide à la manutention",
    text: "Le chauffeur participe au chargement et au déchargement avec les personnes présentes.",
    includes: [
      "Camion et chauffeur",
      "Aide du chauffeur",
      "Chargement et déchargement",
      "Transport",
      "Protection des biens",
    ],
    note: "Pour les objets lourds ou encombrants, une ou plusieurs personnes supplémentaires peuvent être nécessaires.",
    cta: "Choisir cette formule",
    highlighted: false,
  },
  {
    key: "complete",
    value: "Prise en charge complète",
    title: "Prise en charge complète",
    text: "Nous organisons le transport, la manutention et le déménagement avec les moyens humains adaptés.",
    includes: [
      "Camion, chauffeur et équipe de manutention",
      "Protection des biens",
      "Chargement, transport et déchargement",
      "Organisation complète",
      "Démontage simple uniquement s'il est prévu dans le devis",
      "Mise en place selon les conditions convenues",
    ],
    note: null,
    cta: "Demander une prise en charge complète",
    highlighted: true,
  },
];

export const FORMULE_OPTIONS = FORMULES.map((f) => f.value);

export const PILLARS = [
  {
    key: "volumineux",
    icon: Sofa,
    title: "Transport d'objets volumineux",
    text: "Meubles, canapé, armoire, lit, électroménager, piano sous conditions et achats entre particuliers.",
    cta: "Obtenir mon estimation",
    estimateType: "Transport de meubles",
  },
  {
    key: "demenagement",
    icon: Home,
    title: "Déménagement",
    text: "Studio, appartement, maison, déménagement partiel ou complet, selon le volume, les accès et les moyens nécessaires.",
    cta: "Obtenir mon estimation",
    estimateType: "Déménagement",
  },
  {
    key: "longue-distance",
    icon: Route,
    title: "Longue distance",
    text: "Transport depuis Le Havre et la Normandie vers toute la France.",
    cta: "Obtenir mon estimation",
    estimateType: "Longue distance",
  },
  {
    key: "groupage",
    icon: Boxes,
    title: "Groupage",
    text: "Réservez uniquement le volume dont vous avez besoin lorsque plusieurs transports vont vers une même zone.",
    cta: "Vérifier le groupage",
    estimateType: "Groupage",
  },
];

export const REVIEWS_MAIN = [
  {
    name: "Frank S.",
    text: "Yassine est incroyable. Arrivé 15 minutes en avance pour déménager à 8 h du matin, quatre heures de chargement, six heures de route puis le déchargement, le tout avec beaucoup de précaution. Un vrai professionnel, sympathique et souriant, qui transforme une longue journée en déménagement sans stress et sans encombre.",
    date: "30 juin 2026",
    tag: "Très soigneux",
  },
  {
    name: "Lyvie P.",
    text: "Je recommande vivement ce prestataire de déménagement. Une équipe professionnelle, ponctuelle, efficace et très sympathique. Tout s'est déroulé dans les meilleures conditions, avec beaucoup de soin apporté à nos affaires et une excellente organisation du début à la fin.",
    date: "2 juillet 2026",
    tag: "Super réactif",
  },
  {
    name: "Dienaba S.",
    text: "Je recommande cette personne les yeux fermés. Il s'est occupé de mon déménagement du Havre à Darnétal et tout s'est parfaitement déroulé. Il a été ponctuel, professionnel et très soigneux. Tous mes meubles ont été parfaitement protégés et sont arrivés en excellent état.",
    date: "Juillet 2026",
    tag: "Très soigneux",
  },
  {
    name: "Aurélie B.",
    text: "Très bonne expérience. La prestation s'est parfaitement déroulée. Le professionnel a été très gentil, à l'écoute et très clair dans ses explications. Il a su nous mettre à l'aise et nous aider du début à la fin. Je recommande sans hésiter.",
    date: "2 mai 2026",
    tag: "Expert dans son domaine",
  },
  {
    name: "Beston S.",
    text: "Un conducteur expérimenté, très bon dans son travail. Il est arrivé à la mission à l'heure et je suis très satisfait de son travail.",
    date: "9 mai 2026",
    tag: "Super réactif",
  },
  {
    name: "Monique Z.",
    text: "C'est la première fois que nous faisons appel à Yassine. Nous sommes très satisfaites de la prestation et nous le recommandons vivement.",
    date: "11 juin 2026",
    tag: "Très soigneux",
  },
];

export const REVIEWS_SHORT = [
  { name: "Aude C.", text: "Réactif et sympathique." },
  { name: "Melissa H.", text: "Parfait, très gentil, merci encore." },
  { name: "Florantine T.", text: "Très bien, je recommande." },
  { name: "Malory H.", text: "Très gentil, serviable et souriant. Je recommande à 100 %." },
];

export const REVIEWS_DISCLAIMER =
  "Avis laissés par des clients sur la plateforme AlloVoisins. Certains textes peuvent être raccourcis pour faciliter la lecture, sans en modifier le sens.";

export const PROFILE_CARDS = [
  {
    key: "particulier",
    icon: Home,
    title: "Particuliers",
    text: "Transport de meubles, électroménager, achats entre particuliers, déménagement, débarras et longue distance.",
    button: "Obtenir mon estimation",
  },
  {
    key: "entreprise",
    icon: Building2,
    title: "Professionnels",
    text: "Livraisons ponctuelles, transport de matériel, manutention, enlèvements, tournées, facturation et créneaux planifiés.",
    button: "Demander un devis professionnel",
  },
  {
    key: "institution",
    icon: Landmark,
    title: "Institutions et collectivités",
    text: "Devis formel, facturation, organisation, contraintes d'accès, référent unique et planification.",
    button: "Demander un devis institutionnel",
  },
];

export const PRICING_CARDS = [
  { title: "Transport de meubles ou électroménager", text: "Tarif calculé selon le trajet, le volume, les étages, les accès et la manutention." },
  { title: "Déménagement", text: "Proposition adaptée au volume, au nombre de voyages, aux accès et à l'équipe nécessaire." },
  { title: "Longue distance", text: "Camion complet ou groupage selon le volume et la flexibilité des dates." },
  { title: "Manutention", text: "Tarif adapté au nombre de personnes, au poids, au temps et aux contraintes d'accès." },
];

export const PRICING_NOTE =
  "Chaque tarif est confirmé avant intervention. Aucun supplément imprévu n'est appliqué sans validation préalable lorsqu'un changement de périmètre intervient.";

export const WHY_US_ITEMS = [
  { icon: FileText, text: "Tarif confirmé avant intervention" },
  { icon: CalendarCheck, text: "Créneau planifié avec vous" },
  { icon: ShieldCheck, text: "Biens protégés avec couvertures et sangles" },
  { icon: PackageCheck, text: "Chargement organisé et sécurisé" },
  { icon: Users, text: "Manutention possible selon le besoin" },
  { icon: MessageCircle, text: "Communication rapide par téléphone ou WhatsApp" },
  { icon: MapPin, text: "Transport local, régional et longue distance" },
  { icon: Receipt, text: "Facture disponible" },
];

export const HOW_IT_WORKS_STEPS = [
  { title: "Vous décrivez votre besoin", text: "Adresse, date, objets, accès et photos." },
  { title: "Nous évaluons la prestation", text: "Volume, distance, manutention, accès et moyens nécessaires." },
  { title: "Vous recevez une proposition claire", text: "Tarif, périmètre de la prestation et conditions précisés avant validation." },
  { title: "Le créneau est confirmé", text: "La date et l'horaire sont organisés avec vous." },
  { title: "Nous réalisons le transport", text: "Protection, chargement, transport et déchargement selon la formule retenue." },
  { title: "Vous recevez votre reçu ou votre facture", text: "Un reçu ou une facture vous est transmis selon la prestation et les conditions convenues." },
];

export const LONG_DISTANCE_ADVANTAGES = [
  "Camion complet ou volume partagé",
  "Départ depuis Le Havre ou la Normandie",
  "Transport vers toute la France",
  "Biens protégés et sanglés",
  "Devis confirmé à l'avance",
  "Tarif pouvant être optimisé selon le trajet et les possibilités de groupage",
  "Planning organisé avec le client",
];

export const FREQUENT_DESTINATIONS = [
  { label: "Le Havre ↔ Rouen", href: "/transport-le-havre-rouen" },
  { label: "Le Havre ↔ Caen", href: "/transport-le-havre-caen" },
  { label: "Le Havre ↔ Paris", href: "/transport-le-havre-paris" },
  { label: "Le Havre ↔ Bretagne", href: "/transport-le-havre-bretagne" },
  { label: "Le Havre ↔ Hauts-de-France", href: null },
  { label: "Le Havre ↔ Sud de la France", href: null },
];

export const GROUPAGE_OPTIONS = [
  {
    key: "camion-complet",
    icon: Truck,
    title: "Camion complet",
    features: [
      "Véhicule réservé pour votre prestation",
      "Date dédiée",
      "Chargement jusqu'à la capacité autorisée",
      "Tarif forfaitaire",
    ],
  },
  {
    key: "groupage-m3",
    icon: Boxes,
    title: "Groupage au m³",
    features: [
      "Tarif calculé selon le volume",
      "Disponibilité selon les tournées",
      "Délai parfois plus flexible",
      "Adapté aux petits volumes et longues distances",
    ],
  },
];

export const VOLUME_CATEGORIES = [
  {
    key: "salon",
    label: "Salon",
    items: [
      { key: "canape-2p", label: "Canapé 2 places", m3: 1.8 },
      { key: "canape-3p", label: "Canapé 3 places", m3: 2.5 },
      { key: "canape-angle", label: "Canapé d'angle", m3: 3.5 },
      { key: "fauteuil", label: "Fauteuil", m3: 1 },
      { key: "table-basse", label: "Table basse", m3: 0.4 },
      { key: "table-manger", label: "Table à manger", m3: 1.2 },
      { key: "chaise", label: "Chaise", m3: 0.2 },
      { key: "meuble-tv", label: "Meuble TV", m3: 0.8 },
      { key: "television", label: "Télévision", m3: 0.3 },
    ],
  },
  {
    key: "chambre",
    label: "Chambre",
    items: [
      { key: "lit-simple", label: "Lit simple démonté", m3: 0.8 },
      { key: "lit-double", label: "Lit double démonté", m3: 1.2 },
      { key: "sommier-simple", label: "Sommier simple", m3: 0.6 },
      { key: "sommier-double", label: "Sommier double", m3: 1 },
      { key: "matelas-simple", label: "Matelas simple", m3: 0.7 },
      { key: "matelas-double", label: "Matelas double", m3: 1 },
      { key: "armoire-2p", label: "Armoire 2 portes", m3: 1.8 },
      { key: "armoire-3p", label: "Armoire 3 portes", m3: 2.5, heavy: true },
      { key: "commode", label: "Commode", m3: 0.8 },
      { key: "chevet", label: "Table de chevet", m3: 0.2 },
    ],
  },
  {
    key: "electromenager",
    label: "Électroménager",
    items: [
      { key: "lave-linge", label: "Lave-linge", m3: 0.5 },
      { key: "seche-linge", label: "Sèche-linge", m3: 0.5 },
      { key: "lave-vaisselle", label: "Lave-vaisselle", m3: 0.5 },
      { key: "four", label: "Four", m3: 0.3 },
      { key: "cuisiniere", label: "Cuisinière", m3: 0.6 },
      { key: "frigo-standard", label: "Réfrigérateur standard", m3: 1 },
      { key: "frigo-americain", label: "Réfrigérateur américain", m3: 1.6, heavy: true },
      { key: "congelateur", label: "Congélateur", m3: 0.8 },
    ],
  },
  {
    key: "cartons",
    label: "Cartons et bagages",
    items: [
      { key: "petit-carton", label: "Petit carton", m3: 0.05 },
      { key: "carton-standard", label: "Carton standard", m3: 0.1 },
      { key: "grand-carton", label: "Grand carton", m3: 0.15 },
      { key: "sac-demenagement", label: "Sac de déménagement", m3: 0.1 },
      { key: "valise-cabine", label: "Valise cabine", m3: 0.05 },
      { key: "grande-valise", label: "Grande valise", m3: 0.15 },
    ],
  },
  {
    key: "bureau-autres",
    label: "Bureau et autres",
    items: [
      { key: "bureau", label: "Bureau", m3: 1 },
      { key: "chaise-bureau", label: "Chaise de bureau", m3: 0.4 },
      { key: "bibliotheque", label: "Bibliothèque", m3: 1.2 },
      { key: "velo", label: "Vélo", m3: 0.5 },
      { key: "meuble-demonte", label: "Meuble démonté", m3: 0.5 },
      { key: "piano-droit", label: "Piano droit", m3: 1.5, heavy: true },
      { key: "objet-lourd", label: "Objet lourd", m3: 1, heavy: true },
      { key: "autre-objet", label: "Autre objet", m3: 0.5 },
    ],
  },
];

export const VOLUME_HEAVY_NOTICE = "Étude spécifique nécessaire selon le poids, les dimensions et les accès.";
export const VOLUME_DISCLAIMER =
  "Cette estimation de volume est indicative et ne constitue pas un devis. Le volume réel et les conditions de manutention seront confirmés avant validation.";

export const PROOF_PHOTOS = [
  {
    src: "https://static.prod-images.emergentagent.com/jobs/6bb40084-7d0f-45f4-8e2a-3e8e7ccf7633/images/f6766c558028de5579127f97b7223bdfb3f20cda2e08e7a70ae7fdf17e5b2bed.png",
    alt: "Chargement sécurisé avec couvertures et sangles dans le camion",
    caption: "Chargement sécurisé avec couvertures et sangles",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/6bb40084-7d0f-45f4-8e2a-3e8e7ccf7633/images/403f02db4ab54dd8ac76168c2b0b940df7197556c10d8711fbc5529a3d712731.png",
    alt: "Meubles protégés avec couvertures avant transport au Havre",
    caption: "Meubles protégés avant transport",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/6bb40084-7d0f-45f4-8e2a-3e8e7ccf7633/images/251dded69ecad9f5058314324ed0c70e6a94608b96d42d8885bc332dd0e7d0a5.png",
    alt: "Manutention d'électroménager avec matériel adapté",
    caption: "Manutention d'électroménager avec matériel adapté",
  },
];

export const FAQ_CATEGORIES = [
  {
    key: "reservation-tarifs",
    label: "Réservation et tarifs",
    items: [
      { q: "Comment est calculé le prix ?", a: "Selon la distance, le volume, le temps nécessaire, les accès, les étages, la manutention demandée et les possibilités de groupage. Le tarif est confirmé avant intervention." },
      { q: "Faut-il envoyer des photos ?", a: "Ce n'est pas obligatoire, mais c'est recommandé : les photos permettent d'établir une proposition plus précise, plus rapidement." },
      { q: "Comment réserver un créneau ?", a: "Après validation de la proposition, la date et l'horaire sont confirmés avec vous par téléphone, WhatsApp ou email." },
      { q: "Un acompte est-il demandé ?", a: "Selon la prestation, un acompte peut être demandé. Les modalités sont précisées avant validation." },
      { q: "Que se passe-t-il si le volume réel est supérieur au volume annoncé ?", a: "La prestation peut être réévaluée avant le chargement selon le volume supplémentaire, le temps nécessaire, le poids et le nombre de voyages. Aucun changement de tarif n'est appliqué sans information et validation préalable." },
      { q: "Puis-je changer de formule après réception de l'estimation ?", a: "Oui, sous réserve de disponibilité et d'une réévaluation du tarif avant l'intervention." },
      { q: "Peut-on recevoir une facture ?", a: "Oui. Une facture peut être fournie, notamment pour les professionnels et les institutions." },
      { q: "Pouvez-vous intervenir en urgence ?", a: "Selon disponibilité. Contactez-nous par téléphone ou WhatsApp pour vérifier les créneaux possibles." },
    ],
  },
  {
    key: "formules-manutention",
    label: "Formules et manutention",
    items: [
      { q: "Quelle formule choisir ?", a: "Choisissez « Camion + chauffeur » si vous disposez déjà de personnes pour porter. Choisissez « Camion + chauffeur + aide à la manutention » si vous souhaitez que le chauffeur participe au chargement et au déchargement. Pour une prise en charge complète, une équipe adaptée est organisée selon le volume, le poids et les accès." },
      { q: "Le chauffeur peut-il porter seul un objet lourd ?", a: "Non. Certains objets nécessitent obligatoirement deux personnes ou davantage. Le nombre de manutentionnaires est déterminé selon le poids, les dimensions, les étages et les accès." },
      { q: "Combien de manutentionnaires faut-il ?", a: "Cela dépend des objets, des étages et des accès. Le nombre nécessaire est évalué lors de l'étude de votre demande." },
      { q: "Louez-vous le camion seul ?", a: "Non. Les prestations comprennent au minimum le camion et le chauffeur." },
      { q: "Peut-on accompagner le camion ?", a: "Un accompagnement n'est possible que si une place passager légale et disponible est prévue dans le véhicule. La place peut être indisponible lorsqu'une équipe de manutention est mobilisée. La disponibilité doit être confirmée avant la prestation." },
    ],
  },
  {
    key: "preparation-biens",
    label: "Préparation des biens",
    items: [
      { q: "Les appareils doivent-ils être vidés et débranchés ?", a: "Oui. Les réfrigérateurs, congélateurs, machines à laver et autres appareils doivent être vidés, débranchés et préparés avant l'intervention. Les réfrigérateurs et congélateurs doivent être dégivrés si nécessaire." },
      { q: "Transportez-vous les réfrigérateurs ?", a: "Oui. Les réfrigérateurs sont transportés avec précaution, sanglés et maintenus debout autant que possible." },
      { q: "Transportez-vous les pianos ?", a: "Oui, sous conditions. Une étude des dimensions, du poids, des accès, des marches et du nombre de manutentionnaires nécessaires est indispensable." },
      { q: "Les meubles doivent-ils être démontés ?", a: "C'est recommandé pour les meubles volumineux (armoires, lits). Ce point est précisé lors de l'étude de votre demande." },
      { q: "Les objets sont-ils protégés ?", a: "Oui. Les biens sont protégés avec des couvertures et des sangles, et le chargement est organisé pour éviter tout mouvement pendant le transport." },
      { q: "Quelles informations faut-il fournir pour obtenir un tarif ?", a: "Les adresses de départ et d'arrivée, la date souhaitée, la liste des objets, les étages et ascenseurs, et si possible des photos." },
    ],
  },
  {
    key: "longue-distance-groupage",
    label: "Longue distance et groupage",
    items: [
      { q: "Intervenez-vous uniquement au Havre ?", a: "Non. Express Delivery est basé au Havre et intervient dans toute la Normandie. Des transports peuvent être organisés partout en France selon la prestation." },
      { q: "Faites-vous les longues distances ?", a: "Oui. Les transports longue distance sont organisés à l'avance depuis Le Havre et la Normandie vers les autres régions françaises, en camion complet ou en groupage." },
      { q: "Comment fonctionne le groupage ?", a: "Lorsque plusieurs transports vont vers une même zone, ils sont regroupés dans un même camion. Vous payez selon le volume occupé, avec des dates organisées selon les tournées." },
      { q: "Peut-on réserver une partie du camion ?", a: "Oui. Avec le groupage, vous demandez une place dans le camion et payez selon le volume occupé, sous réserve de compatibilité des trajets et des dates." },
    ],
  },
];

export const FAQ_ITEMS = FAQ_CATEGORIES.flatMap((c) => c.items);

export const HERO_VISUAL = "https://static.prod-images.emergentagent.com/jobs/6bb40084-7d0f-45f4-8e2a-3e8e7ccf7633/images/5a41f1447d2da72bcffbc4ba238129a747b78b6d75890bf59cc5391447da7426.png";
export const LONG_DISTANCE_VISUAL = "/images/transport-longue-distance-le-havre.webp";
